import { Component, OnInit } from "@angular/core";
import { AppService } from "src/app/core/services/app.service";
import { CustomerService } from "src/app/core/services/customer.service";
import { OOVenueService } from "src/app/core/services/venue-service";
import { CustomerSubscriptionItem } from "src/app/shared/models/CustomerSubscription.item";

@Component({
	selector: "app-subscription-dashboard-view",
	templateUrl: "./subscription-dashboard-view.component.html",
	styleUrls: ["../../commandcenter.scss"],
})
export class SubscriptionDashboardViewComponent implements OnInit {
	uniqueSubscribers: CustomerSubscriptionItem[] = [];
	dueRange: {
		today: number;
		tomorrow: number;
		thisWeek: number;
		dueTodayItems: {
			item: string;
			quantity: number;
		}[];
		dueTomorrowItems: {
			item: string;
			quantity: number;
		}[];
		dueThisWeekItems: {
			item: string;
			quantity: number;
		}[];
	};
	constructor(public app: AppService, public customerService: CustomerService, public venueService: OOVenueService) {}

	ngOnInit(): void {
		this.customerService.customerSubscriptionItemList.subscribe((subscriptionList) => {
			this.dueRange = { today: 0, tomorrow: 0, thisWeek: 0, dueTodayItems: [], dueTomorrowItems: [], dueThisWeekItems: [] };
			console.log(`refresh ${subscriptionList.length}`);
			this.uniqueSubscribers = [];
			subscriptionList.forEach((subscription) => {
				if (!this.uniqueSubscribers.some((i) => i.customerKey === subscription.customerKey)) {
					this.uniqueSubscribers.push(subscription);
				}
				if (this.app.moment.unix(subscription.nextBillDate).isBefore(this.app.moment().endOf("day"))) {
					this.dueRange.today += 1;
					const dueItem = this.dueRange.dueTodayItems.find((i) => i.item === subscription.ooMenuItem.name);
					if (!dueItem) {
						this.dueRange.dueTodayItems.push({
							item: subscription.ooMenuItem.name,
							quantity: 1,
						});
					} else {
						dueItem.quantity += 1;
					}
				}
				if (this.app.moment.unix(subscription.nextBillDate).isBetween(this.app.moment().endOf("day"), this.app.moment().add(1, "day").endOf("day"))) {
					this.dueRange.tomorrow += 1;
					const dueItem = this.dueRange.dueTomorrowItems.find((i) => i.item === subscription.ooMenuItem.name);
					if (!dueItem) {
						this.dueRange.dueTomorrowItems.push({
							item: subscription.ooMenuItem.name,
							quantity: 1,
						});
					} else {
						dueItem.quantity += 1;
					}
				}
				if (
					this.app.moment
						.unix(subscription.nextBillDate)
						.isBetween(this.app.moment().add(1, "day").endOf("day"), this.app.moment().add("7", "day").endOf("day"))
				) {
					this.dueRange.thisWeek += 1;
					const dueItem = this.dueRange.dueThisWeekItems.find((i) => i.item === subscription.ooMenuItem.name);
					if (!dueItem) {
						this.dueRange.dueThisWeekItems.push({
							item: subscription.ooMenuItem.name,
							quantity: 1,
						});
					} else {
						dueItem.quantity += 1;
					}
				}
			});
		});
	}
}
